<template>
  <div class="activity-center-tabs">
    <span class="activity-center-tabs__label">Status</span>
    <div class="activity-center-tabs__buttons">
      <button
        v-for="tab in tabs"
        :key="tab.name"
        class="activity-center-tabs__btn"
        :class="{ 'activity-center-tabs__btn--active': modelValue === tab.name }"
        @click="$emit('update:modelValue', tab.name)"
      >
        <span
          v-if="tab.dot"
          class="activity-center-tabs__dot"
          :style="{ backgroundColor: tab.dot }"
        ></span>
        <span class="activity-center-tabs__btn-label">
          {{ tab.label }}
          <template v-if="tab.count !== undefined">({{ tab.count }})</template>
        </span>
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ActivityCenterTabs',
    props: {
      modelValue: {
        type: String,
        required: true
      },
      tabs: {
        type: Array,
        required: true
      }
    },
    emits: ['update:modelValue']
  }
</script>

<style lang="scss" scoped>
  .activity-center-tabs {
    padding: 24px;
    background-color: $mi-white;

    &__label {
      display: block;
      font-family: $mi-typography-font-family-condensed;
      font-weight: 700;
      font-size: 14px;
      line-height: 21px;
      color: $mi-anthracite-800;
      margin-bottom: 8px;
    }

    &__buttons {
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: $mi-silver-50;
      border-radius: 6px;
      padding: 4px;
      gap: 4px;
    }

    &__btn {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      flex: 1;
      padding: 8px 16px;
      border: 0;
      border-radius: 4px;
      background: transparent;
      cursor: pointer;
      font-family: $mi-typography-font-family-condensed;
      font-weight: 700;
      font-size: 14px;
      line-height: 21px;
      color: $mi-anthracite-600;
      white-space: nowrap;
      transition: background-color .2s, color .2s;

      &:hover {
        background-color: $mi-silver-100;
      }

      &--active {
        background-color: $mi-anthracite-900;
        color: $mi-white;

        &:hover {
          background-color: $mi-anthracite-900;
        }
      }
    }

    &__btn-label {
      text-decoration: none;
    }

    &__btn:first-child &__btn-label {
      text-decoration: underline;
    }

    &__dot {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      flex-shrink: 0;
    }
  }
</style>
